import React from "react";
import { useState, Suspense, useEffect } from "react";
import "./style.scss";
import { NationalMsgPreivew } from "./components/NationalMsgPreview";
import Template from "../Template";
import Modal from "../../components/Modal";
import LabeledLoader from "../../components/LabeledLoader";
import { getData, getAuthenticatedUser } from "../../utils/requests";
import Filter from "./components/Filter";
import Button from "../../components/Button";
import { adminPermissions } from "../../utils/permissions";

import { reactKeyGenerator } from "../../utils";
import axios from "axios";
import { array, arrayOf, func, node, oneOfType, string } from "prop-types";

const CreateEditNationalMsg = React.lazy(() =>
  import("./components/CreateEditNationalMsg")
);

export default function NationalMessagesCreateEdit() {
  const [fetchCompleted, setFetchCompleted] = useState(false);
  const [authUser, setAuthUser] = useState({});
  const canViewNationalMessages = adminPermissions();
  const [clearForm, setClearForm] = useState(false);
  const [products, setProducts] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(true);
  const [productsApiUrl, setProductsApiUrl] = useState(
    `${process.env.REACT_APP_API_HOST}/api/meta-by-product/?type=product`
  );
  const [brandSelected, setBrandSelected] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState("");
  const [brandChanged, setBrandChanged] = useState(false);
  const [filtered, setFiltered] = useState(false);

  //loading Messages
  const [messages, setMessages] = useState([]);
  const [loadingMessages, setLoadingMessages] = useState(true);
  const [messageApiUrl, setMessageApiUrl] = useState(
    `${process.env.REACT_APP_API_HOST}/api/nationalmessage/?deployment=national&proudct_brand_id=${selectedBrand}`
  );
  //loading states
  const [loadingStates, setLoadingStates] = useState(true);
  const [states, setStates] = useState([]);
  const statesApiURL = `${process.env.REACT_APP_API_HOST}/api/states/`;
  const [currentStatesURL, setCurrentStatesURL] = useState(statesApiURL);
  // Create Msg Modal
  const [createNationalClassName, setCreateNationalClassName] = useState("");
  // Modal sates
  const [modalHeaderText, setModalHeaderText] = useState("");
  const [modalbodyText, setModalBodyText] = useState("");
  const [modalbodyTextTop, setModalBodyTextTop] = useState("");
  const [modalClassName, setModalClassName] = useState("d-none");
  const [hideEdit, setHideEdit] = useState("d-none");
  // first button
  const [modalButtonOneText, setModalButtonOneText] = useState("");
  const [modalButtonOneType, setModalButtonOneType] = useState("");
  const [modalButtonOneClassName, setModalButtonOneClassName] = useState("");
  const [modalButtonOneOnClick, setModalButtonOneOnClick] = useState();
  // second button
  const [modalButtonTwoText, setModalButtonTwoText] = useState("");
  const [modalButtonTwoType, setModalButtonTwoType] = useState("");
  const [modalButtonTwoClassName, setModalButtonTwoClassName] = useState("");
  const [modalButtonTwoOnClick, setModalButtonTwoOnClick] = useState();
  // modal children
  // Using this as a string that will be set as an object Key
  // The currect actie key will be displayed in the modal window
  const [modalChildren, setModalChildren] = useState();
  const modalChildrenContent = {
    preview: <NationalMsgPreivew />,
  };
  const currentModalChildren = modalChildrenContent[modalChildren] || null;

  const [notification, setNotification] = useState("");
  const [notificationClass, setNotificationClass] = useState("d-none");
  const resetNotifications = () => {
    // reset notification to blank
    setNotification("");
    setNotificationClass("");
  };

  // loading users
  const [loadingUsers, setLoadingUsers] = useState(true); // bool: when true, we're fetching the list of users
  const [users, setUsers] = useState([]);
  const [userApiUrl, setUserApiUrl] = useState(
    `${process.env.REACT_APP_API_HOST}/api/user/`
  );

  useEffect(() => {
    getData(userApiUrl, setUserApiUrl, setLoadingUsers, setUsers);
  }, [userApiUrl]);

  const [disabledState, setDisabledState] = useState({ value: "" });
  //loading Priority DataTable
  const [priorities, setPriorities] = useState([]);
  const [brand, setBrand] = useState("");
  const [loadingPriorities, setLoadingPriorities] = useState(true);
  const [prioritiesApiUrl, setPrioritiesApiUrl] = useState(
    `${process.env.REACT_APP_API_HOST}/api/national-priorites-data/`
  );

  useEffect(() => {
    setAuthUser(getAuthenticatedUser);
  }, []);

  useEffect(() => {
    getData(productsApiUrl, setProductsApiUrl, setLoadingProducts, setProducts);
  }, [productsApiUrl]);

  useEffect(() => {
    getData(messageApiUrl, setMessageApiUrl, setLoadingMessages, setMessages);
  }, [messageApiUrl]);

  //loading states
  useEffect(() => {
    getData(currentStatesURL, setCurrentStatesURL, setLoadingStates, setStates);
  }, [currentStatesURL]);

  const handleSaveProperties = () => {
    let payload = [];
    let payloadDelete = [];
    let input_meta = [];
    document.querySelectorAll("input[name^='priority_']").forEach((elm) => {
      // payload[elm.dataset.djangofield] = elm.value;

      let previous = parseInt(
        document
          .querySelector(`input[class=${elm.name}___input]`)
          .getAttribute("aria-label")
      );
      //add or update
      if (parseInt(elm.value) > 0) {
        input_meta = String(elm.name).split("_");
        payload.push(
          Object.assign(
            {},
            {
              message_id: elm.value,
              brand_id: selectedBrand,
              states_id: input_meta[2],
              priorities: input_meta[3],
              status: "ACTIVE",
            }
          )
        );
      }

      if (isNaN(parseInt(elm.value)) && parseInt(previous) > 0) {
        input_meta = String(elm.name).split("_");
        payload.push(
          Object.assign(
            {},
            {
              message_id: null,
              brand_id: selectedBrand,
              states_id: input_meta[2],
              priorities: input_meta[3],
              status: "INACTIVE",
            }
          )
        );
      }
    });

    const submitData = async () => {
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Api-Key ${process.env.REACT_APP_AMP_API_KEY}`,
        },
      };
      let url = `${process.env.REACT_APP_API_HOST}/api/national-priorites-sets/`;
      try {
        await axios.put(`${url}`, payload, headers).then((res) => {
          // Success - Redirect to Dashboard
          window.open("/national-messages", "_self");
        });
      } catch (error) {
        console.log(error);
        setModalClassName("d-none");
        // show error
        setNotification("There was a problem submitting your message.");
        setNotificationClass("notification--show");
        // reset after timeout otherwise the change
        // happens too fast and the modal will
        // not work again
        setTimeout(resetNotifications, 5500);
      }
    };
    submitData();
  };

  const handleCancel = () => {
    window.open("/national-messages/", "_self");
  };

  return (
    <>
      {canViewNationalMessages ? (
        <Template>
          <section className="nationalmsg">
            <h1 className="d-none">National Messages</h1>
            <section className="nationalmsg__header">
              <div className="nationalmsg__products">
                {loadingProducts ? (
                  <LabeledLoader label="Loading products..." />
                ) : (
                  <>
                    <div className="nationalMsg__fields">
                      <Filter
                        name="Products"
                        data={products}
                        setBrandSelected={setBrandSelected}
                        setSelectedBrand={setSelectedBrand}
                        selectedBrand={selectedBrand}
                        setBrandChanged={setBrandChanged}
                        brandChanged={brandChanged}
                      />
                    </div>
                    <div>
                      {messages.filter(
                        (a) =>
                          parseInt(a.proudct_brand_id) ===
                          parseInt(selectedBrand)
                      ).length > 0 ? (
                        <div
                          id="nationalMsg__btns"
                          className="nationalMsg__btns"
                        >
                          <div
                            id="edit-buttons"
                            className="nationalMsg__edit-btns"
                          >
                            <Button
                              text="Save"
                              id="save-priorities-btn"
                              onClick={handleSaveProperties}
                            />

                            <Button
                              text="Cancel"
                              id="cancel-button"
                              onClick={handleCancel}
                            />
                          </div>
                        </div>
                      ) : (
                        <>no message</>
                      )}
                    </div>
                  </>
                )}
              </div>
            </section>
          </section>

          <Suspense fallback={<div>loading...</div>}>
            <CreateEditNationalMsg
              key={`CreateNationalMsg__${reactKeyGenerator}`}
              className={createNationalClassName}
              messages={messages}
              selectedBrand={selectedBrand}
              filtered={filtered}
              loadingStates={loadingStates}
              states={states}
              clearForm={clearForm}
              setClearForm={setClearForm}
              hidden={hideEdit}
              users={users}
              brandChanged={brandChanged}
              setBrandChanged={setBrandChanged}
              setLoadingDefaultPriorities={brandChanged ? true : false}
            />
          </Suspense>

          <Modal
            headerText={modalHeaderText}
            bodyTextTop={modalbodyTextTop}
            bodyText={modalbodyText}
            className={modalClassName}
            buttonOne={[
              modalButtonOneText,
              modalButtonOneType,
              modalButtonOneClassName,
              modalButtonOneOnClick,
            ]}
            buttonTwo={[
              modalButtonTwoText,
              modalButtonTwoType,
              modalButtonTwoClassName,
              modalButtonTwoOnClick,
            ]}
          >
            {currentModalChildren}
          </Modal>
        </Template>
      ) : (
        window.open("/national-messages", "_self")
      )}
    </>
  );
}

NationalMessagesCreateEdit.propTypes = {
  priorities: array,
  messages: array,
  states: array,
  selectedBrand: string,
  setCurrentBrand: func,
};
